import React, { useState, useEffect, useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import { base_url } from "../../utils/axiosConfig";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { FaTimes, FaCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

// List of restricted states and cities
const restrictedLocations = [
  // "Karnataka",
  // "Belagavi",
  // "Bengaluru",
  // "Ballari",
  // "Mangaluru",
  // "Mysuru",
  // "Visakhapatnam",
  // "Pune",
  // "Nashik",
  // "Nagpur",
  // "Ahmedabad",
  // "Delhi",
  // "Kerala",
];

// Static list of union territories in India
const unionTerritoriesList = [
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Lakshadweep",
  "Puducherry",
  "Jammu and Kashmir",
  "Ladakh",
];

const FranchiseSignUp = ({ show, onHide }) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(show);
  // const [categories, setCategories] = useState([]);
  const [selectedGrossAmount, setSelectedGrossAmount] = useState("");

  const [showThankYou, setShowThankYou] = useState(false);
  const [applicationType, setApplicationType] = useState(null);
  const [isSelectedTip, setIsSelectedTip] = useState(false);
  const [loading, setLoading] = useState({
    categories: false,
    countries: false,
    states: false,
    districts: false,
    pincodes: false,
  });
  // const [formData, setFormData] = useState({
  //   category: null,
  //   country: null,
  //   countryStatus: null,
  //   state: null,
  //   stateStatus: null,
  //   district: null,
  //   districtStatus: null,
  //   isMetro: false,
  //   pincode: null,
  //   pincodeStatus: null,
  // });
  const [formData, setFormData] = useState({
    category: "",
    subCategory: "",
  });
  const [options, setOptions] = useState({
    countries: [],
    states: [],
    unionTerritories: [],
    districts: [],
    pincodes: [],
  });
  // State for filter and search in step 2
  const [filterType, setFilterType] = useState("all"); // Options: "all", "states", "unionTerritories"
  const [searchQueryState, setSearchQueryState] = useState("");
  const [searchQueryDistrict, setSearchQueryDistrict] = useState("");
  const [searchQueryPincode, setSearchQueryPincode] = useState("");
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [paymentData, setPaymentData] = useState(null);

  const partnerType =
    window.location.pathname === "/signup/channelpartnerplus"
      ? "channelPartnerPlus"
      : "channelPartner";

  const isPlusMode = partnerType === "channelPartnerPlus";
  const [showFormModal, setShowFormModal] = useState(isPlusMode); // open form directly in plus mode
  const [currentStep, setCurrentStep] = useState(isPlusMode ? -1 : 0);
  // Reference to set Formik field value
  const setFieldValueRef = useRef(null);

  // Handle modal close
  const handleClose = () => {
    setShowModal(false);
    onHide();
  };

  // Check if the current step's selection is available for applying
  const isCurrentStepAvailable = () => {
    switch (currentStep) {
      case 0:
        return formData.category !== null;
      case 1:
        return formData.state && formData.stateStatus === "available";
      case 2:
        return formData.district && formData.districtStatus === "available";
      case 3:
        return formData.pincode && formData.pincodeStatus === "available";
      default:
        return false;
    }
  };

  // Check if the current step's selection is restricted
  const isCurrentStepRestricted = () => {
    switch (currentStep) {
      case 2:
        return restrictedLocations.includes(formData.state);
      case 3:
        return restrictedLocations.includes(
          formData.district?.replace(": Metro", ""),
        );
      case 4:
        return restrictedLocations.includes(formData.pincode);
      default:
        return false;
    }
  };

  // Check if the current step is loading
  const isCurrentStepLoading = () => {
    switch (currentStep) {
      case 0:
        return loading.categories;
      case 1:
        return loading.countries;
      case 2:
        return loading.states;
      case 3:
        return loading.districts;
      case 4:
        return loading.pincodes;
      default:
        return false;
    }
  };

  // Function to generate dynamic heading based on step and formData
  const getDynamicHeading = () => {
    switch (currentStep) {
      case 0:
        return "LifeOnPlus Product Portfolio – Franchise Distribution";
      case 1:
        return formData.country
          ? `Country Partner Login – ${formData.country}`
          : "Country Partner Login";
      case 2:
        return formData.state && formData.country
          ? `State Selection – ${formData.state} (${formData.country})`
          : formData.country
            ? `State Selection – ${formData.country}`
            : "State Selection";
      case 3:
        return formData.district && formData.state
          ? `District Selection – ${formData.district}, ${formData.state}`
          : formData.state
            ? `District Selection – ${formData.state}`
            : "District Selection";
      case 4:
        return formData.district && formData.state
          ? `Pincode and Retailer Selection – ${formData.pincode}, ${formData.district}, ${formData.state}`
          : formData.state
            ? `Pincode and Retailer Selection – ${formData.state}`
            : "Pincode and Retailer Selection";
      default:
        return "Channel Partner Registration";
    }
  };

  // Check if a step is completed
  const isStepCompleted = (stepIndex) => {
    switch (stepIndex) {
      case 0:
        return formData.category !== null;
      case 1:
        return formData.country !== null;
      case 2:
        return formData.state !== null;
      case 3:
        return formData.district !== null;
      case 4:
        return formData.pincode !== null;
      default:
        return false;
    }
  };

  // Get partner level based on current step
  const getLevel = () => {
    switch (currentStep) {
      case 1:
        return "state-director";
      case 2:
        return "district-director";
      case 3:
        return "pincode-director";
      default:
        return "";
    }
  };

  // Form validation schema using Yup
  const validationSchema = [
    // Step 0: Personal Details and Address
    Yup.object().shape({
      name: Yup.string().required("Name is required"),
      email: Yup.string().email("Invalid email").required("Email is required"),
      phone: Yup.string().required("Phone number is required"),
      resAddress_line: Yup.string().required("Residential Address is required"),
      resCountry: Yup.string().required("Residential Country is required"),
      resState: Yup.string().required("Residential State is required"),
      resCity: Yup.string().required("Residential City is required"),
      resDistrict: Yup.string().required("Residential District is required"),
      resPincode: Yup.string().required("Residential Pincode is required"),
      correAddress_line: Yup.string().required(
        "Correspondence/Office Address is required",
      ),
      correCountry: Yup.string().required(
        "Correspondence/Office Country is required",
      ),
      correState: Yup.string().required(
        "Correspondence/Office State is required",
      ),
      correCity: Yup.string().required(
        "Correspondence/Office City is required",
      ),
      correDistrict: Yup.string().required(
        "Correspondence/Office District is required",
      ),
      correPincode: Yup.string().required(
        "Correspondence/Office Pincode is required",
      ),
      dob: Yup.date().required("Date of birth is required"),
      gender: Yup.string().required("Gender is required"),
      profilePhoto: Yup.mixed().required("Profile photo is required"),
    }),
    // Step 1: Bank Details and KYC
    Yup.object().shape({
      bankDetails: Yup.object().shape({
        holderName: Yup.string().notRequired().trim().nullable(),
        bankName: Yup.string().notRequired().trim().nullable(),
        accountNo: Yup.string()
          .notRequired()
          .trim()
          .nullable()
          .matches(/^\d{9,18}$/, {
            message: "Account number must be 9-18 digits",
            excludeEmptyString: true, // ← important: don't validate empty string
          }),
        ifscCode: Yup.string()
          .notRequired()
          .trim()
          .nullable()
          .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, {
            message: "Invalid IFSC code format",
            excludeEmptyString: true,
          }),
      }),
      panCard: Yup.mixed()
        .required("PAN card is required")
        .test(
          "fileType",
          "PAN card must be a PDF, JPG, JPEG, or PNG",
          (value) =>
            value &&
            ["application/pdf", "image/jpeg", "image/png"].includes(value.type),
        ),
      registrationDoc: Yup.mixed()
        .required("Registration Document is required")
        .test(
          "fileType",
          "Registration Document must be a PDF, JPG, JPEG, or PNG",
          (value) =>
            value &&
            ["application/pdf", "image/jpeg", "image/png"].includes(value.type),
        ),
      gstDoc: Yup.mixed()
        .required("GST Document is required")
        .test(
          "fileType",
          "GST Document must be a PDF, JPG, JPEG, or PNG",
          (value) =>
            value &&
            ["application/pdf", "image/jpeg", "image/png"].includes(value.type),
        ),
      panCardNo: Yup.string()
        .matches(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/, "Invalid PAN card number format")
        .required("PAN card number is required"),
      businessName: Yup.string().required("Business Name is required"),
      gstNo: Yup.string(),
    }),
    // Step 2: Referral Code
    Yup.object().shape({
      referralCode: Yup.string(),
    }),
    // Step 3: Transaction Details
    Yup.object().shape({
      // transactionId: Yup.string().required("Transaction ID is required"),
      // transferType: Yup.string().required("Transfer type is required"),
      // amount: Yup.number()
      //   .required("Total amount is required")
      //   .positive("Total amount must be positive"),
      grossAmount: Yup.number()
        .required("Base amount is required")
        .positive("Base amount must be positive"),
      // gstAddedAmount: Yup.number()
      //   .required("GST amount is required")
      //   .positive("GST amount must be positive"),
      // screenshot: Yup.mixed().required("Payment screenshot is required"),
    }),
    // Step 4: Terms and Conditions
    Yup.object().shape({
      agreement: Yup.boolean()
        .required("You must agree to the Terms and Conditions")
        .oneOf([true], "You must agree to the Terms and Conditions"),
    }),
  ];

  // Toggle form modal visibility
  const handleShowFormModal = (type) => {
    if (
      type === "retailer" ||
      (isCurrentStepAvailable() &&
        !isCurrentStepLoading() &&
        !isCurrentStepRestricted())
    ) {
      setApplicationType(type);
      setShowFormModal(true);
    }
  };

  const handleCloseFormModal = () => {
    setShowFormModal(false);
    setApplicationType(null);
    navigate("/");
  };

  // Toggle thank you message
  const handleCloseThankYou = () => {
    setShowThankYou(false);
    setShowFormModal(false);
    setCurrentStep(0);
    setApplicationType(null);
    setFormData({
      category: null,
      country: null,
      countryStatus: null,
      state: null,
      stateStatus: null,
      district: null,
      districtStatus: null,
      isMetro: false,
      pincode: null,
      pincodeStatus: null,
    });
    setFilterType("all");
    setSearchQueryState("");
    setSearchQueryDistrict("");
    setSearchQueryPincode("");
  };

  // Navigation handlers
  const handlePrevious = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  // Update form data with status
  const handleSelect = (key, value, status = null, isMetro = false) => {
    setFormData((prevData) => {
      if (key === "category" && prevData.category !== value) {
        setOptions({
          countries: [],
          states: [],
          unionTerritories: [],
          districts: [],
          pincodes: [],
        });
        return {
          category: value,
          country: "India",
          countryStatus: null,
          state: null,
          stateStatus: null,
          district: null,
          districtStatus: null,
          isMetro: false,
          pincode: null,
          pincodeStatus: null,
        };
      }
      let resetFields = {};
      if (key === "country") {
        resetFields = {
          state: null,
          stateStatus: null,
          district: null,
          districtStatus: null,
          isMetro: false,
          pincode: null,
          pincodeStatus: null,
        };
        setOptions((prev) => ({
          ...prev,
          states: [],
          unionTerritories: [],
          districts: [],
          pincodes: [],
        }));
      } else if (key === "state") {
        resetFields = {
          district: null,
          districtStatus: null,
          isMetro: false,
          pincode: null,
          pincodeStatus: null,
        };
        setOptions((prev) => ({ ...prev, districts: [], pincodes: [] }));
      } else if (key === "district") {
        resetFields = {
          pincode: null,
          pincodeStatus: null,
        };
        setOptions((prev) => ({ ...prev, pincodes: [] }));
      }
      return {
        ...prevData,
        [key]: value,
        ...(status ? { [`${key}Status`]: status } : {}),
        ...(key === "district" ? { isMetro } : {}),
        ...resetFields,
      };
    });
  };

  // Fetch categories
  const fetchVerticalProducts = async () => {
    setLoading((prev) => ({ ...prev, categories: true }));
    try {
      const response = await fetch(
        `${base_url}v1/vertical/getAllProdcts?page=1&limit=100`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      if (!response.ok)
        throw new Error(`HTTP error! status: ${response.status}`);
      const data = await response.json();
      // setCategories(data?.mainProducts || []);
    } catch (error) {
      console.error("Error fetching categories:", error);
    } finally {
      setLoading((prev) => ({ ...prev, categories: false }));
    }
  };

  // Fetch countries based on category
  useEffect(() => {
    if (formData.category) {
      setLoading((prev) => ({ ...prev, countries: true }));
      axios
        .post(
          `${base_url}v1/user/country-availability?mainProductId=${formData.category}&partnerType=${partnerType}`,
        )
        .then((response) => {
          const countriesData =
            response.data.data?.filter((e) => e.name === "India") || [];
          setOptions((prev) => ({ ...prev, countries: countriesData }));
        })
        .catch((error) => {
          console.error("Error fetching countries:", error);
          setOptions((prev) => ({ ...prev, countries: [] }));
        })
        .finally(() => {
          setLoading((prev) => ({ ...prev, countries: false }));
        });
    }
  }, [formData.category]);

  // Fetch states and union territories based on country and search
  useEffect(() => {
    if (formData.country === "India") {
      setLoading((prev) => ({ ...prev, states: true }));
      axios
        .post(
          `${base_url}v1/user/state-availability-director?mainProductId=${
            formData.category
          }&partnerType=${partnerType}&country=India&search=${encodeURIComponent(
            searchQueryState,
          )}`,
        )
        .then((response) => {
          const data = response.data || [];
          // Separate states and union territories using the static list
          const states = data.filter(
            (item) => !unionTerritoriesList.includes(item.name),
          );
          const unionTerritories = data.filter((item) =>
            unionTerritoriesList.includes(item.name),
          );
          setOptions((prev) => ({ ...prev, states, unionTerritories }));
        })
        .catch((error) => {
          console.error("Error fetching states:", error);
          setOptions((prev) => ({
            ...prev,
            states: [],
            unionTerritories: [],
            districts: [],
            pincodes: [],
          }));
        })
        .finally(() => {
          setLoading((prev) => ({ ...prev, states: false }));
        });
    } else if (formData.country === "International") {
      setOptions((prev) => ({
        ...prev,
        states: [{ name: "N/A", status: "available" }],
        unionTerritories: [],
        districts: [],
        pincodes: [],
      }));
      setFormData((prev) => ({
        ...prev,
        state: null,
        stateStatus: null,
        district: null,
        districtStatus: null,
        isMetro: false,
        pincode: null,
        pincodeStatus: null,
      }));
    } else {
      setOptions((prev) => ({
        ...prev,
        states: [],
        unionTerritories: [],
        districts: [],
        pincodes: [],
      }));
      setFormData((prev) => ({
        ...prev,
        state: null,
        stateStatus: null,
        district: null,
        districtStatus: null,
        isMetro: false,
        pincode: null,
        pincodeStatus: null,
      }));
    }
  }, [formData.country, formData.category, searchQueryState]);

  // Fetch districts based on state and search
  useEffect(() => {
    if (formData.state && formData.state !== "N/A") {
      setLoading((prev) => ({ ...prev, districts: true }));
      axios
        .post(
          `${base_url}v1/user/district-availability-director?mainProductId=${
            formData.category
          }&partnerType=${partnerType}&country=India&state=${
            formData.state
          }&search=${encodeURIComponent(searchQueryDistrict)}`,
        )
        .then((response) => {
          const districts = response.data || [];
          setOptions((prev) => ({ ...prev, districts }));
        })
        .catch((error) => {
          console.error("Error fetching districts:", error);
          setOptions((prev) => ({ ...prev, districts: [], pincodes: [] }));
          setFormData((prev) => ({
            ...prev,
            district: null,
            districtStatus: null,
            isMetro: false,
            pincode: null,
            pincodeStatus: null,
          }));
        })
        .finally(() => {
          setLoading((prev) => ({ ...prev, districts: false }));
        });
    } else {
      setOptions((prev) => ({ ...prev, districts: [], pincodes: [] }));
      setFormData((prev) => ({
        ...prev,
        district: null,
        districtStatus: null,
        isMetro: false,
        pincode: null,
        pincodeStatus: null,
      }));
    }
  }, [formData.state, formData.category, searchQueryDistrict]);

  // Fetch pincodes based on district and search
  useEffect(() => {
    if (formData.district) {
      setLoading((prev) => ({ ...prev, pincodes: true }));
      const districtName = formData.district.replace(": Metro", "");
      axios
        .post(
          `${base_url}v1/user/pincode-availability-director?mainProductId=${
            formData.category
          }&partnerType=${partnerType}&country=India&state=${
            formData.state
          }&district=${districtName}&search=${encodeURIComponent(
            searchQueryPincode,
          )}`,
        )
        .then((response) => {
          const pincodes = response.data || [];
          setOptions((prev) => ({ ...prev, pincodes }));
        })
        .catch((error) => {
          console.error("Error fetching pincodes:", error);
          setOptions((prev) => ({ ...prev, pincodes: [] }));
          setFormData((prev) => ({
            ...prev,
            pincode: null,
            pincodeStatus: null,
          }));
        })
        .finally(() => {
          setLoading((prev) => ({ ...prev, pincodes: false }));
        });
    } else {
      setOptions((prev) => ({ ...prev, pincodes: [] }));
      setFormData((prev) => ({ ...prev, pincode: null, pincodeStatus: null }));
    }
  }, [
    formData.district,
    formData.category,
    formData.state,
    searchQueryPincode,
  ]);

  const fetchPaymentData = async () => {
    try {
      const response = await axios.get(`${base_url}v1/user/partnerPaymentData`);
      setPaymentData(response.data.data.directorPayment);
    } catch (error) {
      console.error("Error fetching payment data:", error);
    }
  };

  useEffect(() => {
    fetchPaymentData();
    fetchVerticalProducts();
  }, []);

  const steps = ["LifeOnPlus Product Portfolio – Franchise Distribution"];

  // Toggle description for a specific product
  const toggleDescription = (productId) => {
    setExpandedDescriptions((prev) => ({
      ...prev,
      [productId]: !prev[productId],
    }));
  };

  // Get short description (truncate to 100 characters)
  const getShortDescription = (description) => {
    if (!description) return "No description available.";
    return description.length > 50
      ? description.slice(0, 50) + "..."
      : description;
  };

  // const SelectionCard = ({
  //   index, // <-- pass index when rendering in map
  //   region,
  //   item,
  //   isSelected,
  //   registeredBy,
  //   status,
  //   img,
  //   onClick,
  //   type = "card",
  //   isMetro = false,
  //   isDisabled = false,
  //   description,
  //   productId,
  // }) => {
  //   let tooltipMessage = "";

  //   if (region === "Country") {
  //     tooltipMessage = `Click on <span style="color: #FFA500; ">Proceed to register as Country Partner</span>. Or, if you want to register as State/UT Director, click on the Country and then click <span style="color: #FF8C00; ">Proceed to select your State/UT</span>.`;
  //   } else if (region === "State") {
  //     tooltipMessage = `Click on <span style="color: #FFA500; ">Proceed to register as State Director</span>. Or, if you want to register as District Director, click on the State/UT and then click <span style="color: #FF8C00; ">Proceed to select your District</span>.`;
  //   } else if (region === "District") {
  //     tooltipMessage = `Click on <span style="color: #FFA500; ">Proceed to register as District Director</span>. Or, if you want to register as Pincode Director, click on the District and then click <span style="color: #FF8C00; ">Proceed to select your Pincode</span>.`;
  //   } else if (region === "Pincode") {
  //     tooltipMessage = `Click on <span style="color: #FFA500; ">Proceed to register as Pincode Director</span>. Or, if you want to register as Retailer, click on <span style="color: #FFA500; ">Proceed to register as Retailer</span>.`;
  //   }

  //   const displayName =
  //     isMetro && type === "list"
  //       ? `${item.replace(": Metro", "")} (Metro)`
  //       : item;

  //   const isRestricted = restrictedLocations.includes(
  //     item.replace(": Metro", ""),
  //   );

  //   // Only toggle tooltip if the card is selected
  //   const handleMouseEnter = () => {
  //     if (isSelected) {
  //       setIsSelectedTip(true);
  //     }
  //   };

  //   const handleMouseLeave = () => {
  //     setIsSelectedTip(false);
  //   };

  //   // ✅ Decide tooltip side based on index (4 cards per row)
  //   const isRightSide = index % 4 === 0 || index % 4 === 1;
  //   return (
  //     <div
  //       onClick={isDisabled ? null : () => onClick(item, status, isMetro)}
  //       onMouseEnter={handleMouseEnter}
  //       onMouseLeave={handleMouseLeave}
  //       className={`relative cursor-pointer border-gray-500 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-200 ${
  //         isDisabled
  //           ? "bg-gray-300 cursor-not-allowed"
  //           : isRestricted
  //             ? "bg-[#FFA500]"
  //             : status === "available"
  //               ? "bg-green-400"
  //               : "bg-red-600"
  //       } ${isSelected ? "ring-2 ring-black" : ""} ${
  //         type === "card"
  //           ? "bg-white p-2"
  //           : "flex items-center h-14 px-4 w-32 sm:w-40"
  //       }`}
  //     >
  //       {/* Tooltip (show when selected) */}
  //       {isSelected && isSelectedTip && type == "list" && (
  //         <div
  //           className={`absolute w-80 top-1/2 -translate-y-1/2 bg-black text-white text-xs font-medium px-3 py-2 rounded-lg shadow-md z-20 max-w-xs whitespace-normal ${
  //             isRightSide
  //               ? "left-full ml-2 text-left"
  //               : "right-full mr-2 text-left"
  //           }`}
  //         >
  //           <div dangerouslySetInnerHTML={{ __html: tooltipMessage }} />
  //           {/* Arrow */}
  //           <div
  //             className={`absolute top-1/2 -translate-y-1/2 w-3 h-3 bg-black rotate-45 ${
  //               isRightSide ? "-left-1.5" : "-right-1.5"
  //             }`}
  //           ></div>
  //         </div>
  //       )}

  //       {type === "card" ? (
  //         <div className="flex flex-col items-center">
  //           <div
  //             className="w-full h-32 bg-gray-200 rounded-t-lg bg-cover"
  //             style={{ backgroundImage: `url(${img})` }}
  //           ></div>
  //           <span className="text-md font-['Roboto'] text-center text-black py-2">
  //             {displayName}
  //           </span>
  //           {description && (
  //             <div className="text-xs font-['Poppins'] text-gray-600 px-2 pb-2 text-center">
  //               {expandedDescriptions[productId] ? (
  //                 <>
  //                   {description}
  //                   <button
  //                     onClick={(e) => {
  //                       e.stopPropagation();
  //                       toggleDescription(productId);
  //                     }}
  //                     className="text-blue-600 hover:underline ml-1 text-xs"
  //                   >
  //                     Read Less
  //                   </button>
  //                 </>
  //               ) : (
  //                 <>
  //                   {getShortDescription(description)}
  //                   {description.length > 50 && (
  //                     <button
  //                       onClick={(e) => {
  //                         e.stopPropagation();
  //                         toggleDescription(productId);
  //                       }}
  //                       className="text-blue-600 hover:underline ml-1 text-xs"
  //                     >
  //                       Read More
  //                     </button>
  //                   )}
  //                 </>
  //               )}
  //             </div>
  //           )}
  //         </div>
  //       ) : (
  //         <span className="text-sm font-['Roboto'] text-black truncate">
  //           {displayName} {registeredBy ? `- ${registeredBy} ` : ""}
  //         </span>
  //       )}

  //       {isDisabled && (
  //         <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 rounded-lg pointer-events-none">
  //           <span className="text-white text-sm font-['Poppins'] font-semibold">
  //             Coming Soon
  //           </span>
  //         </div>
  //       )}
  //     </div>
  //   );
  // };
  const categories = [
    {
      _id: "68b05ce0952ecd0e50a97834",
      mainProductName: "DNP (Digital And Physical  Emergency Health Kit)",
      description: "Complete medical kiosk setup",
      price: 2800000,
      isEnabled: false,
      images: ["https://via.placeholder.com/300x200?text=Kiosk"],
    },
    {
      _id: "4",
      mainProductName: "DGS (Diagnosis)",
      description: "Complete medical kiosk setup",
      price: 2800000,
      isEnabled: false,
      images: ["https://via.placeholder.com/300x200?text=Kiosk"],
    },
    {
      _id: "68b177cf952ecd0e50a97bcd",
      mainProductName: "QHC (Quick Health Checkup)",
      description: "Advanced express medical testing solution",
      price: 800000,
      isEnabled: true,
      images: ["https://via.placeholder.com/300x200?text=Express+Medical+Test"],
    },
    {
      _id: "68b05eaf952ecd0e50a978ad",
      mainProductName: "XMT (Express Medical Test)",
      description: "Advanced express medical testing solution",
      price: 800000,
      isEnabled: true,

      images: ["https://via.placeholder.com/300x200?text=Express+Medical+Test"],
    },

    {
      _id: "68b15f9a952ecd0e50a97b92",
      mainProductName: "BRS (Body Recharge Station)",
      description: "Complete body recharge station with 4 wellness modules",
      isEnabled: true,

      images: [
        "https://via.placeholder.com/300x200?text=Body+Recharge+Station",
      ],

      subCategories: [
        {
          _id: "2-1",
          mainProductName: "Body Screening",
          description: "Body screening medical module",
          price: 1000000,
          isEnabled: true,

          images: ["https://via.placeholder.com/300x200?text=Body+Screening"],
        },

        {
          _id: "2-2",
          mainProductName: "MEOL",
          description: "MEOL health technology module",
          price: 2600000,
          isEnabled: true,

          images: ["https://via.placeholder.com/300x200?text=MEOL"],
        },

        {
          _id: "2-3",
          mainProductName: "IMRS",
          description: "IMRS wellness system",
          price: 1800000,
          isEnabled: true,

          images: ["https://via.placeholder.com/300x200?text=IMRS"],
        },

        {
          _id: "2-4",
          mainProductName: "Food Detox",
          description: "Food detoxification module",
          price: 1500000,
          isEnabled: true,

          images: ["https://via.placeholder.com/300x200?text=Food+Detox"],
        },
      ],
    },

    {
      _id: "68b1683c952ecd0e50a97ba3",
      mainProductName: "SCE (Scalar Energy)",
      description: "Scalar energy wellness solution",
      price: 300000,
      isEnabled: false,

      images: ["https://via.placeholder.com/300x200?text=Scalar+Energy"],
    },

    {
      _id: "68b05ffc952ecd0e50a978bf",
      mainProductName: "KSK (Kiosk)",
      description: "Complete medical kiosk setup",
      price: 2800000,
      isEnabled: false,

      images: ["https://via.placeholder.com/300x200?text=Kiosk"],
    },

    {
      _id: "1",
      mainProductName: "FDS (Food Supplements)",
      description: "Complete medical kiosk setup",
      price: 2800000,
      isEnabled: false,

      images: ["https://via.placeholder.com/300x200?text=Kiosk"],
    },
    {
      _id: "2",
      mainProductName: "WTP (Wearable Technological Products)",
      description: "Complete medical kiosk setup",
      price: 2800000,
      isEnabled: false,

      images: ["https://via.placeholder.com/300x200?text=Kiosk"],
    },
    {
      _id: "3",
      mainProductName: "RPM (Remote Patient Monitoring)",
      description: "Complete medical kiosk setup",
      price: 2800000,
      isEnabled: false,

      images: ["https://via.placeholder.com/300x200?text=Kiosk"],
    },

    {
      _id: "5",
      mainProductName: "AI (Artificial Intelligence)",
      description: "Complete medical kiosk setup",
      price: 2800000,
      isEnabled: false,

      images: ["https://via.placeholder.com/300x200?text=Kiosk"],
    },
  ];

  const [selectedCategory, setSelectedCategory] = useState(null);

  const handleCategorySelect = (category) => {
    setSelectedCategory(category);
    setSelectedGrossAmount(category.price);

    setFormData((prev) => ({
      ...prev,
      category: category._id,
      subCategory: "",
    }));
  };

  const handleSubCategorySelect = (subCategory) => {
    setSelectedGrossAmount(subCategory.price);
    setFormData((prev) => ({
      ...prev,
      subCategory: subCategory._id,
    }));
  };

  const SelectionCard = ({
    index,
    item,
    isSelected,
    img,
    onClick,
    description,
    productId,
    price,
    disabled,
  }) => {
    return (
      <div
        onClick={!disabled ? onClick : undefined}
        className={`relative border rounded-lg shadow-md transition-all duration-200 bg-white overflow-hidden ${
          disabled
            ? "opacity-60 cursor-not-allowed"
            : "cursor-pointer hover:shadow-lg"
        } ${isSelected ? "ring-2 ring-green-600" : ""}`}
      >
        {/* Coming Soon Badge */}
        {disabled && (
          <div className="absolute top-2 right-2 z-10 bg-warning text-dark px-2 py-1 rounded text-xs fw-bold">
            Coming Soon
          </div>
        )}

        <div className="flex flex-col items-center">
          <div
            className="w-full h-40 bg-gray-200 rounded-t-lg bg-cover bg-center"
            style={{
              backgroundImage: `url(${img})`,
            }}
          ></div>

          <span className="text-md font-semibold text-center text-black py-2 px-2">
            {item}
          </span>

          {price && (
            <div className="text-green-700 font-bold text-lg pb-2">
              ₹ {Number(price).toLocaleString("en-IN")}
            </div>
          )}

          {description && (
            <div className="text-xs text-gray-600 px-3 pb-3 text-center">
              {description}
            </div>
          )}
        </div>
      </div>
    );
  };

  const subheadings = [
    "Select a product category to begin your Franchise registration.",
  ];
  const instructions = [
    "LifeOnPlus presents a unique opportunity to be part of a global healthcare distribution ecosystem by selecting the product(s) you wish to represent and leading sales, marketing, and distribution within your chosen territory. Our portfolio covers the below spectrum of innovative health solutions.",
  ];

  const formatIndianNumber = (num) => {
    return num.toLocaleString("en-IN"); // e.g. 18000000 => 1,80,00,000
  };

  const formatAmount = (label, amount) => {
    if (!amount) return `${label}: N/A`;
    console.log("here2222");
    return `${label}: ₹${formatIndianNumber(amount)}`;
  };

  const getAmount = (step) => {
    console.log(step);
    if (!paymentData) return "Loading...";

    const config = LEVEL_MAP[step];
    if (!config) return "";

    // STEP 1 & 2 (no metro concept in array)
    if (step === 1) {
      return formatSingleOrRange(
        config.label,
        getAmounts({
          paymentData,
          partnerType,
          levelKey:
            partnerType === "channelPartner"
              ? config.objectKey
              : config.arrayLevel,
        }),
      );
    }

    // STEP 3 (District)
    if (step === 2) {
      // channelPartner → metro / non-metro
      if (partnerType === "channelPartner") {
        return [
          formatSingleOrRange(
            "District (Metro)",
            getAmounts({
              paymentData,
              partnerType,
              levelKey: config.objectKey.metro,
            }),
          ),
          formatSingleOrRange(
            "District (Non-Metro)",
            getAmounts({
              paymentData,
              partnerType,
              levelKey: config.objectKey.nonMetro,
            }),
          ),
        ].join(" | ");
      }

      // channelPartnerPlus → single range
      return formatSingleOrRange(
        "District",
        getAmounts({
          paymentData,
          partnerType,
          levelKey: config.arrayLevel,
        }),
      );
    }

    // STEP 4 (Pincode + Retailer)
    if (step === 3) {
      return [
        formatSingleOrRange(
          "Pincode (Metro)",
          getAmounts({
            paymentData,
            partnerType,
            levelKey: config.objectKey.metro,
          }),
        ),
        formatSingleOrRange(
          "Pincode (Non-Metro)",
          getAmounts({
            paymentData,
            partnerType,
            levelKey: config.objectKey.nonMetro,
          }),
        ),
      ].join(" | ");
    }

    return "";
  };

  const formatSingleOrRange = (label, amounts) => {
    console.log(amounts, label);
    if (!amounts.length) return `${label}: N/A`;

    if (amounts.length === 1) {
      return formatAmount(label, amounts[0]);
    }

    const min = Math.min(...amounts);
    const max = Math.max(...amounts);

    return `: ₹${min.toLocaleString()} - ₹${max.toLocaleString()}`;
  };

  const getAmounts = ({ paymentData, partnerType, levelKey }) => {
    if (!paymentData) return [];

    // channelPartner → object
    if (partnerType === "channelPartner") {
      const value = paymentData[levelKey];
      return value !== undefined ? [value] : [];
    }

    // channelPartnerPlus → array
    return paymentData
      .filter((item) => item.level === levelKey)
      .map((item) => item.amount);
  };

  const LEVEL_MAP = {
    1: {
      label: "State",
      objectKey: "state",
      arrayLevel: "state-partner",
    },
    2: {
      label: "District",
      objectKey: {
        metro: "districtMetro",
        nonMetro: "districtNonMetro",
      },
      arrayLevel: "district-partner",
    },
    3: {
      label: "Pincode",
      objectKey: {
        metro: "pincodeMetro",
        nonMetro: "pincodeNonMetro",
      },
      arrayLevel: "pincode-partner",
    },
  };

  // Reusable step component with scrollable content and loading state
  const StepContent = ({ step }) => (
    <div className="flex flex-col justify-center min-h-[500px] sm:min-h-[700px] p-4 sm:p-6">
      <div className="sticky top-0 z-30 bg-white shadow-md py-4 px-4 sm:px-6">
        <h1 className="text-lg sm:text-lg font-['Poppins'] font-bold text-gray-900">
          {getDynamicHeading()}
        </h1>
      </div>
      <div className="mb-6">
        <h2 className="text-xl sm:text-2xl font-['Poppins'] font-semibold text-gray-800 mb-2">
          {steps[step]}
        </h2>
        <p className="text-lg font-['Poppins'] text-gray-600 mb-2 font-semibold">
          Steps to register as Franchise
        </p>
        <p className="text-[14px] font-['Poppins'] text-gray-600 font-semibold">
          {instructions[step]}
        </p>
        <p className="text-[13px] font-['Poppins'] mt-3 text-gray-400 font-semibold">
          {subheadings[step]}
        </p>
        <div>
          {step > 0 && (
            <div className="flex items-center gap-2 text-xs font-['Poppins']">
              <span className="flex items-center">
                <span className="w-3 h-3 bg-green-400 rounded-full mr-1"></span>{" "}
                Active/Available
              </span>
              <span className="flex items-center">
                <span className="w-3 h-3 bg-red-600 rounded-full mr-1"></span>{" "}
                Allotted/Unavailable
              </span>
              <span className="flex items-center">
                <span className="w-3 h-3 bg-[#FFA500] rounded-full mr-1"></span>{" "}
                In Process/Pending
              </span>
            </div>
          )}
        </div>
        <div>
          {step > 0 && (
            <p className="text-[13px] font-['Poppins'] mt-2 text-gray-700 font-semibold">
              Amount {getAmount(step)}
            </p>
          )}
        </div>
      </div>

      {isCurrentStepLoading() ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-orange-600"></div>
        </div>
      ) : (
        <>
          {step === 0 && (
            <>
              {" "}
              <h2 className="text-2xl font-bold mb-4">Select Category</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                {categories.map((category, index) => (
                  <SelectionCard
                    key={category._id}
                    index={index}
                    item={category.mainProductName}
                    img={category.images[0]}
                    price={category.price}
                    description={category.description}
                    productId={category._id}
                    disabled={!category.isEnabled}
                    isSelected={formData.category === category._id}
                    onClick={() => {
                      if (category.isEnabled) {
                        handleCategorySelect(category);
                      }
                    }}
                  />
                ))}
              </div>
              {/* SUB CATEGORY SECTION */}
              {selectedCategory?.subCategories?.length > 0 && (
                <>
                  <h2 className="text-2xl font-bold mt-8 mb-4">
                    Select Module
                  </h2>

                  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
                    {selectedCategory.subCategories.map(
                      (subCategory, index) => (
                        <SelectionCard
                          key={subCategory._id}
                          index={index}
                          item={subCategory.mainProductName}
                          img={subCategory.images[0]}
                          price={subCategory.price}
                          description={subCategory.description}
                          productId={subCategory._id}
                          isSelected={formData.subCategory === subCategory._id}
                          onClick={() => handleSubCategorySelect(subCategory)}
                        />
                      ),
                    )}
                  </div>
                </>
              )}
            </>
          )}
        </>
      )}
      <div className="mt-8 flex justify-between space-x-2">
        <div className="flex space-x-2">
          <button
            onClick={() => handleShowFormModal("pincode-partner")}
            disabled={
              !isCurrentStepAvailable() ||
              isCurrentStepLoading() ||
              isCurrentStepRestricted()
            }
            className="px-4 py-2 bg-[#1DA1F2] text-white font-['Poppins'] rounded-lg  transition-colors duration-200 disabled:bg-gray-300 disabled:text-gray-600"
          >
            Register as Franchise
          </button>
        </div>
      </div>
    </div>
  );

  useEffect(() => {
    const completeSignup = async () => {
      const formData = JSON.parse(localStorage.getItem("signupFormData"));
      const orderId = localStorage.getItem("cashfreeOrderId");
      const customerId = localStorage.getItem("cashfreeCustomerId");

      if (!orderId || !formData) return;

      const finalFormData = new FormData();

      // append ALL signup fields again
      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null && formData[key] !== undefined) {
          finalFormData.append(key, formData[key]);
        }
      });

      // append orderId (IMPORTANT)
      finalFormData.append("orderId", orderId);
      finalFormData.append("customerId", customerId);

      // await axios.post(`${base_url}v1/user/userPartner/signUp`, finalFormData, {
      //   headers: { "Content-Type": "multipart/form-data" },
      // });

      localStorage.removeItem("signupFormData");
      localStorage.removeItem("cashfreeOrderId");
    };

    completeSignup();
  }, []);

  // Application Form Modal
  const ApplicationFormModal = () => {
    const partnerType =
      window.location.pathname === "/signup/channelpartnerplus"
        ? "channelPartnerPlus"
        : "channelPartner";
    const formEnabled =
      partnerType === "channelPartnerPlus" || applicationType === "retailer"
        ? true
        : isCurrentStepAvailable() && !isCurrentStepRestricted();
    const [step, setStep] = useState(0);
    const [paymentData, setPaymentData] = useState(null);
    const [isRegistered, setIsRegistered] = useState(false);
    const [referralData, setReferralData] = useState(null);
    const [useSameAddress, setUseSameAddress] = useState(false);
    const [plan, setPlan] = useState("");
    const [referralCodeInput, setReferralCodeInput] = useState("");
    const formSteps = [
      "Personal Details",
      "Bank Details & KYC",
      "Referral Code",
      "Transaction Details",
      "Terms and Conditions",
    ];
    const [isInstallment, setIsInstallment] = useState(false);
    const [payingAmount, setPayingAmount] = useState("");
    const [couponCode, setCouponCode] = useState("");
    const [discount, setDiscount] = useState({
      type: null,
      value: 0,
      id: null,
    });
    const [couponError, setCouponError] = useState("");
    const [couponDetails, setCouponDetails] = useState(null);
    const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);

    const handleRemoveCoupon = () => {
      setCouponCode("");
      setDiscount({ type: null, value: 0, id: null });
      setCouponError("");
      setCouponDetails(null);
      toast.success("Coupon removed successfully!");
    };

    const handleApplyCoupon = async () => {
      if (!couponCode) {
        setCouponError("Please enter a coupon code.");
        return;
      }

      setIsApplyingCoupon(true);
      try {
        const response = await fetch(
          `${base_url}coupon/getCoupon/${couponCode}?type=franchise`,
        );

        const result = await response.json();
        if (!response.ok) {
          throw new Error(result.message || "Invalid coupon code.");
        }

        const coupon = result.data;
        const currentDate = new Date();
        const startDate = new Date(coupon.startDate);
        const expirationDate = new Date(coupon.expirationDate);

        if (coupon.status !== "active") {
          throw new Error("Coupon is not active.");
        }
        if (currentDate < startDate || currentDate > expirationDate) {
          throw new Error("Coupon is expired or not yet valid.");
        }
        const amounts = getAmountDetails();
        if (
          coupon.discountType === "flat" &&
          coupon.discountValue > amounts.grossAmount
        ) {
          throw new Error("Invalid Coupon");
        }

        setDiscount({
          type: coupon.discountType,
          value: coupon.discountValue,
          id: coupon._id,
        });
        setCouponDetails({
          title: coupon.title,
          description: coupon.description,
          couponCode: coupon.couponCode,
          discountType: coupon.discountType,
          discountValue: coupon.discountValue,
          type: coupon.type,
        });
        setCouponError("");
        toast.success("Coupon applied successfully!");
      } catch (error) {
        setCouponError(error.message);
        setDiscount({ type: null, value: 0, id: null });
        setCouponDetails(null);
        toast.error(error.message);
      } finally {
        setIsApplyingCoupon(false);
      }
    };

    const formatIndianNumber = (num) => {
      return num.toLocaleString("en-IN");
    };

    const calculateAmountDetails = (grossAmount, discount, couponDetails) => {
      const gstRate = 0.18;

      // ---------------- COUPON DISCOUNT ----------------
      let couponDiscount = 0;

      const isSignupCoupon = couponDetails?.type === "franchise_signup";

      const isTrainingCoupon =
        couponDetails?.type === "franchise_training_discount";

      // signup => discount on gross
      if (isSignupCoupon) {
        if (discount?.type === "percentage") {
          couponDiscount = +((grossAmount * discount.value) / 100).toFixed(2);
        } else if (discount?.type === "flat") {
          couponDiscount = discount.value;
        }

        if (couponDiscount > grossAmount) {
          couponDiscount = grossAmount;
        }
      }

      // ---------------- GROSS AFTER DISCOUNT ----------------
      // IMPORTANT:
      // even platform discount should reduce gross amount

      const discountedGross = +(grossAmount - couponDiscount).toFixed(2);

      // ---------------- SETUP (30% GST INCLUDED) ----------------

      const setupTotal = +(discountedGross * 0.3).toFixed(2);

      const setupBase = +(setupTotal / (1 + gstRate)).toFixed(2);

      const setupGST = +(setupTotal - setupBase).toFixed(2);

      // ---------------- PLATFORM ----------------

      // ---------------- PLATFORM (3 MONTHS) ----------------
      const months = 3;
      const monthlyTotal = discountedGross * 0.05;

      const platformTotalOriginal = monthlyTotal * months;

      // training => discount only on platform fee
      if (isTrainingCoupon) {
        if (discount?.type === "percentage") {
          couponDiscount = +(
            (platformTotalOriginal * discount.value) /
            100
          ).toFixed(2);
        } else if (discount?.type === "flat") {
          couponDiscount = discount.value;
        }

        if (couponDiscount > platformTotalOriginal) {
          couponDiscount = platformTotalOriginal;
        }
      }

      const discountedPlatform = isTrainingCoupon
        ? +(platformTotalOriginal - couponDiscount).toFixed(2)
        : platformTotalOriginal;

      // PLAN DISCOUNT (10%)

      const planDiscount = +(discountedPlatform * 0.1).toFixed(2);

      const platformAfterPlan = +(discountedPlatform - planDiscount).toFixed(2);

      const platformBase = +(platformAfterPlan / (1 + gstRate)).toFixed(2);

      const platformGST = +(platformAfterPlan - platformBase).toFixed(2);

      // ---------------- ROYALTY ----------------
      // ---------------- ROYALTY ----------------

      // 2% of gross amount
      const royaltyBase = +(discountedGross * 0.01).toFixed(2);

      const royaltyGST = +(royaltyBase * gstRate).toFixed(2);

      const royaltyTotal = +(royaltyBase + royaltyGST).toFixed(2);

      // ---------------- SECURITY DEPOSIT ----------------

      const securityDeposit = +(
        discountedGross -
        setupTotal -
        (isTrainingCoupon ? platformTotalOriginal : discountedPlatform) -
        royaltyTotal
      ).toFixed(2);

      return {
        grossAmount,
        discountedGross,
        couponDiscount,

        setup: {
          total: setupTotal,
          base: setupBase,
          gst: setupGST,
        },

        platform: {
          totalOriginal: platformTotalOriginal,
          discountedPlatform,
          planDiscount,
          totalFinal: platformAfterPlan,
          base: platformBase,
          gst: platformGST,
          months,
        },

        royalty: {
          total: royaltyTotal,
          base: royaltyBase,
          gst: royaltyGST,
        },

        securityDeposit,
      };
    };

    const getAmountDetails = () => {
      const grossAmount = payingAmount
        ? Number(payingAmount)
        : Number(selectedGrossAmount) || 0;

      return calculateAmountDetails(grossAmount, discount, couponDetails);
    };

    const getPartnerApplyAddress = () => {
      if (isPlusMode) return null; // or "" — as per your backend requirement
      const level = getLevel();
      switch (level) {
        case "state-director":
          return formData.state || "";
        case "district-director":
          return formData.district?.replace(": Metro", "") || "";
        case "pincode-director":
          return formData.pincode || "";
        default:
          return "";
      }
    };
    // NEW: Open form directly when in plus mode (on mount)
    useEffect(() => {
      if (isPlusMode && show) {
        setShowModal(false);
        setShowFormModal(true);
      }
    }, [isPlusMode, showFormModal, show]);

    const fetchPaymentData = async () => {
      try {
        const response = await axios.get(
          `${base_url}v1/user/partnerPaymentData`,
        );
        setPaymentData(response.data.data.directorPayment);
      } catch (error) {
        console.error("Error fetching payment data:", error);
      }
    };

    useEffect(() => {
      if (!setFieldValueRef.current) return;
      const details = getAmountDetails();
      console.log(details);
      if (!details) return;
      setFieldValueRef.current("amount", details.totalAmount);
      setFieldValueRef.current("grossAmount", details.grossAmount);
      setFieldValueRef.current("actualAmount", details.baseAmount);
      setFieldValueRef.current("gstAddedAmount", details.gstAddedAmount);
    }, [step, paymentData, selectedGrossAmount, plan]);

    const handleNextStep = async (values, setSubmitting) => {
      if (step === 0) {
        setStep(1);
      } else if (step === 1) {
        setStep(2);
      } else if (step === 2) {
        await fetchPaymentData();
        setStep(3);
      } else if (step === 3) {
        setStep(4);
      }
      setSubmitting(false);
    };

    return (
      <Modal
        show={showFormModal}
        onHide={handleCloseFormModal}
        centered
        backdrop="static"
        dialogClassName="modal-90w md:modal-lg"
      >
        <Modal.Body className="p-4 md:p-6">
          <div className="relative bg-white rounded-lg">
            <button
              onClick={handleCloseFormModal}
              className="absolute top-2 right-2 bg-transparent border-0"
            >
              <FaTimes size={16} color="#666" />
            </button>
            {!isRegistered && (
              <div className="text-center mb-4">
                <h3 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-[#00C70D] to-[#005AD0] bg-clip-text text-transparent">
                  Franchise Sign Up
                </h3>
                <p className="text-gray-500 text-xs md:text-sm">
                  {step === 0
                    ? "Fill in your details to sign up as a Franchise"
                    : step === 1
                      ? "Enter bank details and Company Business documents (Pan Card Only required)"
                      : step === 2
                        ? "Enter referral code (optional)"
                        : step === 3
                          ? "Check and Verify Payment details (All fields required)"
                          : "Review and agree to the terms and conditions (Required)"}
                </p>
                {!isPlusMode && isCurrentStepRestricted() && (
                  <p className="text-red-600 text-xs md:text-sm mt-2">
                    Warning: The selected{" "}
                    {steps[currentStep]
                      .toLowerCase()
                      .replace("(required)", "")
                      .replace("select ", "")}{" "}
                    is restricted and cannot be applied for directly. You can
                    apply as a retailer or proceed to the next step.
                  </p>
                )}
              </div>
            )}
            {isRegistered ? (
              <div className="text-center py-6">
                <h2 className="text-lg md:text-xl font-bold text-green-600">
                  Registration Successful
                </h2>
                <svg
                  className="w-10 h-10 mx-auto text-green-600 mt-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M5 13l4 4L19 7"
                  />
                </svg>
              </div>
            ) : (
              <>
                {!isPlusMode && !formEnabled && step === 0 && (
                  <div className="mb-4 p-4 bg-red-100 text-red-600 rounded-lg font-['Poppins'] text-sm">
                    The selected{" "}
                    {steps[currentStep]
                      .toLowerCase()
                      .replace("(required)", "")
                      .replace("select ", "")}{" "}
                    is not available or restricted. Please choose an available,
                    non-restricted option to proceed with the application, or
                    continue to the next step.
                  </div>
                )}
                <Formik
                  initialValues={{
                    name: "",
                    email: "",
                    phone: "",
                    partnerApplyAddress: getPartnerApplyAddress(),
                    resAddress_line: "",
                    resCountry: "",
                    resState: "",
                    resCity: "",
                    resDistrict: "",
                    resPincode: "",
                    correAddress_line: "",
                    correCountry: "",
                    correState: "",
                    correCity: "",
                    correDistrict: "",
                    correPincode: "",
                    dob: "",
                    gender: "",
                    profilePhoto: null,
                    businessName: "",
                    gstNo: "",
                    bankDetails: {
                      holderName: "",
                      bankName: "",
                      accountNo: "",
                      ifscCode: "",
                    },
                    gstDoc: null,
                    registrationDoc: null,
                    panCard: null,
                    panCardNo: "", // New field for PAN Card Number
                    referralCode: referralCodeInput,
                    // transactionId: "",
                    // transferType: "",
                    amount: "",
                    grossAmount: "",
                    gstAddedAmount: "",
                    // screenshot: null,
                    agreement: false,
                  }}
                  validationSchema={validationSchema[step]}
                  onSubmit={async (values, { setSubmitting, resetForm }) => {
                    if (step < formSteps.length - 1) {
                      handleNextStep(values, setSubmitting);
                      return;
                    }
                    try {
                      const formDataToSend = new FormData();

                      formDataToSend.append("mainProductId", formData.category);
                      formDataToSend.append("name", values.name);
                      formDataToSend.append("email", values.email);
                      formDataToSend.append("phone", values.phone);
                      formDataToSend.append(
                        "address_line",
                        values.resAddress_line,
                      );
                      formDataToSend.append("country", values.resCountry);
                      formDataToSend.append("state", values.resState);
                      formDataToSend.append("city", values.resCity);
                      formDataToSend.append("district", values.resDistrict);
                      formDataToSend.append("pincode", values.resPincode);
                      formDataToSend.append(
                        "correAddress_line",
                        values.correAddress_line,
                      );
                      formDataToSend.append(
                        "correCountry",
                        values.correCountry,
                      );
                      formDataToSend.append("correState", values.correState);
                      formDataToSend.append("correCity", values.correCity);
                      formDataToSend.append(
                        "correDistrict",
                        values.correDistrict,
                      );
                      formDataToSend.append(
                        "correPincode",
                        values.correPincode,
                      );
                      formDataToSend.append("dob", values.dob);
                      formDataToSend.append("gender", values.gender);
                      formDataToSend.append(
                        "profilePhoto",
                        values.profilePhoto,
                      );
                      if (values.businessName) {
                        formDataToSend.append(
                          "businessName",
                          values.businessName,
                        );
                      }
                      if (values.gstNo) {
                        formDataToSend.append("gstNo", values.gstNo);
                      }
                      formDataToSend.append(
                        "holderName",
                        values.bankDetails.holderName || "",
                      );
                      formDataToSend.append(
                        "accountNo",
                        values.bankDetails.accountNo || "",
                      );
                      formDataToSend.append(
                        "ifscCode",
                        values.bankDetails.ifscCode || "",
                      );
                      formDataToSend.append(
                        "bankName",
                        values.bankDetails.bankName || "",
                      );
                      if (values.referralCode) {
                        formDataToSend.append("referredBy", referralData._id);
                      }
                      formDataToSend.append("gstDoc", values.gstDoc);
                      formDataToSend.append(
                        "registrationDoc",
                        values.registrationDoc,
                      );
                      formDataToSend.append("panCard", values.panCard);
                      formDataToSend.append("panCardNo", values.panCardNo); // Append new field
                      if (values.referralCode) {
                        formDataToSend.append("referredBy", referralData._id);
                      }
                      const amountBreakdown = getAmountDetails();
                      formDataToSend.append(
                        "amount",
                        amountBreakdown.setup.total +
                          amountBreakdown.platform.totalFinal +
                          amountBreakdown.royalty.total +
                          amountBreakdown.securityDeposit,
                      );
                      formDataToSend.append("grossAmount", values.grossAmount);

                      formDataToSend.append(
                        "amountDetails",
                        JSON.stringify(amountBreakdown),
                      );
                      formDataToSend.append("agreement", values.agreement);
                      const url = `${base_url}v1/franchise/franchiseSignUp`;
                      const response = await axios.post(url, formDataToSend, {
                        headers: {
                          "Content-Type": "multipart/form-data",
                        },
                      });

                      if (!response.data.paymentSessionId) {
                        setIsRegistered(true);
                      }

                      // 4️⃣ Redirect to Cashfree
                      const cashfree = new window.Cashfree();
                      cashfree
                        .checkout({
                          paymentSessionId: response.data.paymentSessionId,
                          redirectTarget: "_self",
                          mode: "production", // ✅ REQUIRED
                        })
                        .then((result) => {
                          console.log("Checkout result:", result);
                        })
                        .catch((err) => {
                          console.error("Checkout error:", err);
                        });

                      resetForm();
                    } catch (error) {
                      console.error("Registration error:", error);
                    } finally {
                      setSubmitting(false);
                    }
                  }}
                >
                  {({ isSubmitting, setFieldValue, values, errors }) => {
                    setFieldValueRef.current = setFieldValue;
                    const amountBreakdown = getAmountDetails();
                    console.log(amountBreakdown);
                    if (!amountBreakdown) values.amount = "";
                    return (
                      <Form className="flex flex-col gap-4 font-['Poppins']">
                        {step === 0 && (
                          <>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Name <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  type="text"
                                  name="name"
                                  placeholder="Enter Name"
                                  disabled={!formEnabled}
                                    className={`modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500 ${
                                      !formEnabled
                                        ? "opacity-75 cursor-not-allowed"
                                        : ""
                                    }`}
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Email <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  type="email"
                                  name="email"
                                  placeholder="Enter Email"
                                  disabled={!formEnabled}
                                  className={`modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500 ${
                                    !formEnabled
                                      ? "opacity-75 cursor-not-allowed"
                                      : ""
                                  }`}
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Phone <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  type="text"
                                  name="phone"
                                  placeholder="Enter Phone Number"
                                  disabled={!formEnabled}
                                  className={`modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500 ${
                                    !formEnabled
                                      ? "opacity-75 cursor-not-allowed"
                                      : ""
                                  }`}
                                />
                                <ErrorMessage
                                  name="phone"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Date of Birth{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  type="date"
                                  name="dob"
                                  disabled={!formEnabled}
                                  className={`modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500 ${
                                    !formEnabled
                                      ? "opacity-75 cursor-not-allowed"
                                      : ""
                                  }`}
                                  max={new Date().toISOString().split("T")[0]}
                                />
                                <ErrorMessage
                                  name="dob"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Gender <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  as="select"
                                  name="gender"
                                  disabled={!formEnabled}
                                  className={`modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500 ${
                                    !formEnabled
                                      ? "opacity-75 cursor-not-allowed"
                                      : ""
                                  }`}
                                >
                                  <option value="">Select Gender</option>
                                  <option value="Male">Male</option>
                                  <option value="Female">Female</option>
                                  <option value="Other">Other</option>
                                </Field>
                                <ErrorMessage
                                  name="gender"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Profile Photo{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <button
                                  type="button"
                                  className={`w-full mt-1 p-2 bg-[#00C70D] text-white rounded-lg text-sm hover:bg-green-700 transition-colors duration-200 ${
                                    !formEnabled
                                      ? "opacity-75 cursor-not-allowed"
                                      : ""
                                  }`}
                                  disabled={!formEnabled}
                                  onClick={() =>
                                    document
                                      .getElementById("profilePhoto")
                                      .click()
                                  }
                                >
                                  Upload
                                </button>
                                <input
                                  type="file"
                                  id="profilePhoto"
                                  name="profilePhoto"
                                  accept="image/*"
                                  disabled={!formEnabled}
                                  className="hidden"
                                  onChange={(event) => {
                                    if (formEnabled) {
                                      setFieldValue(
                                        "profilePhoto",
                                        event.currentTarget.files[0],
                                      );
                                    }
                                  }}
                                />
                                {values.profilePhoto && (
                                  <div className="mt-1 text-xs text-green-600">
                                    {values.profilePhoto.name ||
                                      "File uploaded"}
                                  </div>
                                )}
                                <ErrorMessage
                                  name="profilePhoto"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                            </div>
                            <div className="mt-4">
                              <h3 className="text-sm md:text-base font-semibold mb-2">
                                Residential / Owner Address{" "}
                                <span className="text-red-500">*</span>
                              </h3>
                              <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    Street Address{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="resAddress_line"
                                    placeholder="Enter Street Address"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="resAddress_line"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    City <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="resCity"
                                    placeholder="Enter City"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="resCity"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    District{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="resDistrict"
                                    placeholder="Enter District"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="resDistrict"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    Pincode{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="resPincode"
                                    placeholder="Enter Pincode"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="resPincode"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    Country{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="resCountry"
                                    placeholder="Enter Country"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="resCountry"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    State{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="resState"
                                    placeholder="Enter State"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="resState"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                              </div>
                            </div>
                            {/* Checkbox */}
                            <div className="mt-2">
                              <label className="flex items-center text-sm font-medium text-gray-700 cursor-pointer">
                                <input
                                  type="checkbox"
                                  checked={useSameAddress}
                                  onChange={(e) => {
                                    const checked = e.target.checked;
                                    setUseSameAddress(checked);
                                    if (checked) {
                                      setFieldValue(
                                        "correAddress_line",
                                        values.resAddress_line || "",
                                      );
                                      setFieldValue(
                                        "correCountry",
                                        values.resCountry || "",
                                      );
                                      setFieldValue(
                                        "correState",
                                        values.resState || "",
                                      );
                                      setFieldValue(
                                        "correCity",
                                        values.resCity || "",
                                      );
                                      setFieldValue(
                                        "correDistrict",
                                        values.resDistrict || "",
                                      );
                                      setFieldValue(
                                        "correPincode",
                                        values.resPincode || "",
                                      );
                                    } else {
                                      // Optional: clear correspondence fields when unchecked
                                      setFieldValue("correAddress_line", "");
                                      setFieldValue("correCountry", "");
                                      setFieldValue("correState", "");
                                      setFieldValue("correCity", "");
                                      setFieldValue("correDistrict", "");
                                      setFieldValue("correPincode", "");
                                    }
                                  }}
                                  className="h-4 w-4 text-green-600 focus:ring-green-500 border-gray-300 rounded mr-2"
                                />
                                <span>
                                  Same as Residential Address (for Franchise
                                  Address)
                                </span>
                              </label>
                            </div>
                            <div className="mt-4">
                              <h3 className="text-sm md:text-base font-semibold mb-2">
                                Franchise Address{" "}
                                <span className="text-red-500">*</span>
                              </h3>
                              <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    Street Address{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="correAddress_line"
                                    placeholder="Enter Street Address"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="correAddress_line"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    City <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="correCity"
                                    placeholder="Enter City"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="correCity"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    District{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="correDistrict"
                                    placeholder="Enter District"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="correDistrict"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    Pincode{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="correPincode"
                                    placeholder="Enter Pincode"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="correPincode"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    Country{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="correCountry"
                                    placeholder="Enter Country"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="correCountry"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                                <div>
                                  <label className="block text-xs md:text-xs font-semibold">
                                    State{" "}
                                    <span className="text-red-500">*</span>
                                  </label>
                                  <Field
                                    type="text"
                                    name="correState"
                                    placeholder="Enter State"
                                    className="modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  />
                                  <ErrorMessage
                                    name="correState"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                              </div>
                            </div>
                          </>
                        )}
                        {step === 1 && (
                          <>
                            <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Business Name <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  type="text"
                                  name="businessName"
                                  placeholder="Enter Business Name"
                                  disabled={!formEnabled}
                                  className={`modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500 ${
                                    !formEnabled
                                      ? "opacity-75 cursor-not-allowed"
                                      : ""
                                  }`}
                                />
                                <ErrorMessage
                                  name="businessName"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  GST Number
                                </label>
                                <Field
                                  type="text"
                                  name="gstNo"
                                  placeholder="Enter GST Number"
                                  disabled={!formEnabled}
                                  className={`modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500 ${
                                    !formEnabled
                                      ? "opacity-75 cursor-not-allowed"
                                      : ""
                                  }`}
                                />
                                <ErrorMessage
                                  name="gstNo"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Company PAN Card Number{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <Field
                                  type="text"
                                  name="panCardNo"
                                  placeholder="Enter PAN Card Number"
                                  className={`modern-input w-full mt-1 p-2 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500 ${
                                    !formEnabled
                                      ? "opacity-75 cursor-not-allowed"
                                      : ""
                                  }`}
                                />
                                <ErrorMessage
                                  name="panCardNo"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  GST Document{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <button
                                  type="button"
                                  className="w-full mt-1 p-2 bg-[#00C70D] text-white rounded-lg text-sm hover:bg-green-700 transition-colors duration-200"
                                  onClick={() =>
                                    document.getElementById("gstDoc").click()
                                  }
                                >
                                  Upload
                                </button>
                                <input
                                  type="file"
                                  id="gstDoc"
                                  name="gstDoc"
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  className="hidden"
                                  onChange={(event) =>
                                    setFieldValue(
                                      "gstDoc",
                                      event.currentTarget.files[0],
                                    )
                                  }
                                />
                                {values.gstDoc && (
                                  <div className="mt-1 text-xs text-green-600">
                                    {values.gstDoc.name || "File uploaded"}
                                  </div>
                                )}
                                <ErrorMessage
                                  name="gstDoc"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>

                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Registration Document{" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <button
                                  type="button"
                                  className="w-full mt-1 p-2 bg-[#00C70D] text-white rounded-lg text-sm hover:bg-green-700 transition-colors duration-200"
                                  onClick={() =>
                                    document
                                      .getElementById("registrationDoc")
                                      .click()
                                  }
                                >
                                  Upload
                                </button>
                                <input
                                  type="file"
                                  id="registrationDoc"
                                  name="registrationDoc"
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  className="hidden"
                                  onChange={(event) =>
                                    setFieldValue(
                                      "registrationDoc",
                                      event.currentTarget.files[0],
                                    )
                                  }
                                />
                                {values.registrationDoc && (
                                  <div className="mt-1 text-xs text-green-600">
                                    {values.registrationDoc.name ||
                                      "File uploaded"}
                                  </div>
                                )}
                                <ErrorMessage
                                  name="registrationDoc"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              <div>
                                <label className="block text-xs md:text-xs font-semibold">
                                  Company KYC (Pan Card){" "}
                                  <span className="text-red-500">*</span>
                                </label>
                                <button
                                  type="button"
                                  className="w-full mt-1 p-2 bg-[#00C70D] text-white rounded-lg text-sm hover:bg-green-700 transition-colors duration-200"
                                  onClick={() =>
                                    document.getElementById("panCard").click()
                                  }
                                >
                                  Upload
                                </button>
                                <input
                                  type="file"
                                  id="panCard"
                                  name="panCard"
                                  accept=".pdf,.jpg,.jpeg,.png"
                                  className="hidden"
                                  onChange={(event) =>
                                    setFieldValue(
                                      "panCard",
                                      event.currentTarget.files[0],
                                    )
                                  }
                                />
                                {values.panCard && (
                                  <div className="mt-1 text-xs text-green-600">
                                    {values.panCard.name || "File uploaded"}
                                  </div>
                                )}
                                <ErrorMessage
                                  name="panCard"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                            </div>
                          </>
                        )}
                        {step === 2 && (
                          <>
                            <div className="grid grid-cols-1 gap-4">
                              <div>
                                <label className="block text-sm md:text-sm font-semibold">
                                  Referral Code (Optional)
                                </label>
                                <Field
                                  type="text"
                                  name="referralCode"
                                  placeholder="Enter Referral Code"
                                  className="modern-input w-full mt-1 p-2.5 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  onChange={(e) => {
                                    setFieldValue(
                                      "referralCode",
                                      e.target.value,
                                    );
                                    setReferralCodeInput(e.target.value);
                                  }}
                                />
                                <ErrorMessage
                                  name="referralCode"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                              {referralData ? (
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                  <div>
                                    <label className="block text-sm md:text-sm font-semibold">
                                      Name
                                    </label>
                                    <input
                                      type="text"
                                      value={referralData.name}
                                      disabled
                                      className="modern-input w-full mt-1 p-2.5 text-sm border-gray-300 bg-gray-100 rounded-lg opacity-75 cursor-not-allowed"
                                    />
                                  </div>
                                  <div>
                                    <label className="block text-sm md:text-sm font-semibold">
                                      Mobile
                                    </label>
                                    <input
                                      type="text"
                                      value={
                                        referralData.phone ||
                                        referralData.mobile
                                      }
                                      disabled
                                      className="modern-input w-full mt-1 p-2.5 text-sm border-gray-300 bg-gray-100 rounded-lg opacity-75 cursor-not-allowed"
                                    />
                                  </div>
                                </div>
                              ) : (
                                <>
                                  {values.referralCode && (
                                    <div className="text-red-500 text-xs mt-1">
                                      Invalid Referral Code
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </>
                        )}
                        {step === 3 && (
                          <>
                            {/* AMOUNT BREAKDOWN */}
                            <div className="mt-4">
                              <h3 className="text-base md:text-lg font-semibold mb-2">
                                Amount Breakdown
                              </h3>

                              {amountBreakdown?.setup ? (
                                <div className="bg-gray-50 p-4 rounded-lg border space-y-4">
                                  {/* GROSS + COUPON */}
                                  <div className="bg-green-50 p-3 rounded border">
                                    <div className="flex justify-between text-sm">
                                      <span>Gross Amount</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.grossAmount,
                                        )}
                                      </span>
                                    </div>

                                    {amountBreakdown.couponDiscount > 0 && (
                                      <>
                                        <div className="flex justify-between text-sm text-green-600">
                                          <span>
                                            Coupon{" "}
                                            {discount?.type === "percentage" &&
                                              `(${discount.value}%)`}
                                            {discount?.type === "flat" &&
                                              `(₹${formatIndianNumber(discount.value)})`}
                                            {discount?.code &&
                                              ` [${discount.code}]`}
                                          </span>
                                          <span>
                                            - ₹
                                            {formatIndianNumber(
                                              amountBreakdown.couponDiscount,
                                            )}
                                          </span>
                                        </div>

                                        <div className="flex justify-between text-sm font-semibold">
                                          <span>Discounted Gross</span>
                                          <span>
                                            ₹
                                            {formatIndianNumber(
                                              amountBreakdown.discountedGross,
                                            )}
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  </div>

                                  {/* SETUP */}
                                  <div className="border-b pb-2">
                                    <p className="font-semibold">
                                      Setup Fee (30% - GST Included)
                                    </p>

                                    <div className="flex justify-between text-sm">
                                      <span>Total</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.setup.total,
                                        )}
                                      </span>
                                    </div>

                                    <div className="flex justify-between text-sm text-gray-600">
                                      <span>Base</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.setup.base,
                                        )}
                                      </span>
                                    </div>

                                    <div className="flex justify-between text-sm text-orange-600">
                                      <span>GST</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.setup.gst,
                                        )}
                                      </span>
                                    </div>
                                  </div>

                                  {/* PLATFORM */}
                                  <div className="border-b pb-2">
                                    <p className="font-semibold">
                                      Training and Market Support fee (5% per
                                      months) ({amountBreakdown.platform.months}{" "}
                                      Months)
                                    </p>

                                    <div className="flex justify-between text-sm">
                                      <span>Original Amount</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.platform
                                            .totalOriginal,
                                        )}
                                      </span>
                                    </div>

                                    {/* PLAN DISCOUNT */}
                                    <div className="flex justify-between text-sm text-blue-600">
                                      <span>
                                        Plan Discount (10% - 3 Months)
                                      </span>
                                      <span>
                                        - ₹
                                        {formatIndianNumber(
                                          amountBreakdown.platform.planDiscount,
                                        )}
                                      </span>
                                    </div>

                                    {/* FINAL */}
                                    <div className="flex justify-between text-sm font-semibold">
                                      <span>Final Payable</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.platform.totalFinal,
                                        )}
                                      </span>
                                    </div>

                                    {/* GST */}
                                    <div className="flex justify-between text-sm text-gray-600">
                                      <span>Base</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.platform.base,
                                        )}
                                      </span>
                                    </div>

                                    <div className="flex justify-between text-sm text-orange-600">
                                      <span>GST</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.platform.gst,
                                        )}
                                      </span>
                                    </div>
                                  </div>

                                  {/* ROYALTY */}
                                  <div className="border-b pb-2">
                                    <p className="font-semibold">
                                      Royalty (1% Every Month and GST Extra)
                                    </p>

                                    <div className="flex justify-between text-sm">
                                      <span>Base</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.royalty.base,
                                        )}
                                      </span>
                                    </div>

                                    <div className="flex justify-between text-sm text-orange-600">
                                      <span>GST</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.royalty.gst,
                                        )}
                                      </span>
                                    </div>

                                    <div className="flex justify-between text-sm font-semibold">
                                      <span>Total</span>
                                      <span>
                                        ₹
                                        {formatIndianNumber(
                                          amountBreakdown.royalty.total,
                                        )}
                                      </span>
                                    </div>
                                  </div>

                                  {/* SECURITY DEPOSIT */}
                                  <div className="flex justify-between text-sm font-bold text-gray-900">
                                    <span>Non Refundable security deposit</span>
                                    <span>
                                      ₹
                                      {formatIndianNumber(
                                        amountBreakdown.securityDeposit,
                                      )}
                                    </span>
                                  </div>

                                  {/* TOTAL PAYABLE */}
                                  <div className="flex justify-between pt-3 border-t font-bold text-lg">
                                    <span>Total Payable</span>
                                    <span>
                                      ₹
                                      {formatIndianNumber(
                                        amountBreakdown.setup.total +
                                          amountBreakdown.platform.totalFinal +
                                          amountBreakdown.royalty.total +
                                          amountBreakdown.securityDeposit,
                                      )}
                                    </span>
                                  </div>
                                </div>
                              ) : (
                                <p className="text-sm text-gray-500">
                                  Enter amount to see breakdown
                                </p>
                              )}
                            </div>

                            <div className="mb-3">
                              <label className="block text-sm md:text-sm font-semibold">
                                Coupon Code
                              </label>

                              <div className="d-flex gap-2">
                                <input
                                  className="modern-input w-full mt-1 p-2.5 text-sm border-gray-300 bg-gray-100 rounded-lg focus:ring-2 focus:ring-green-500"
                                  value={couponCode}
                                  onChange={(e) =>
                                    setCouponCode(e.target.value)
                                  }
                                  placeholder="Enter coupon code"
                                  disabled={couponDetails}
                                />

                                <Button
                                  variant="success"
                                  onClick={handleApplyCoupon}
                                  disabled={!couponCode || couponDetails}
                                >
                                  Apply
                                </Button>
                              </div>

                              {couponError && (
                                <div className="text-danger small mt-1">
                                  {couponError}
                                </div>
                              )}

                              {couponDetails && (
                                <div className="mt-3 p-2.5 border border-success border-opacity-50 rounded bg-success-subtle d-flex flex-wrap justify-content-between align-items-center gap-2">
                                  <div>
                                    <h6 className="mb-1 text-success fw-bold">
                                      {couponDetails.title}
                                    </h6>

                                    <p className="mb-0 small text-success">
                                      <strong>Discount:</strong>{" "}
                                      {couponDetails.discountType ===
                                      "percentage"
                                        ? `${couponDetails.discountValue}% off`
                                        : `₹${couponDetails.discountValue} off`}
                                    </p>
                                  </div>

                                  <Button
                                    variant="outline-danger"
                                    size="sm"
                                    onClick={handleRemoveCoupon}
                                    disabled={isApplyingCoupon}
                                  >
                                    Remove
                                  </Button>
                                </div>
                              )}
                            </div>
                            {/* <div className="mt-4 bg-white p-4 rounded-lg border border-gray-200">
                              <h3 className="text-sm md:text-lg font-semibold mb-3">
                                Payment Option
                              </h3> */}

                            {/* Installment Checkbox */}
                            {/* {partnerType !== "channelPartnerPlus" && (
                              <div className="flex items-center mb-3">
                                <input
                                  type="checkbox"
                                  id="installment"
                                  checked={isInstallment}
                                  onChange={(e) => {
                                    setIsInstallment(e.target.checked);
                                    if (!e.target.checked) setPayingAmount("");
                                  }}
                                  className="mr-2"
                                />
                                <label
                                  htmlFor="installment"
                                  className="text-sm text-gray-700"
                                >
                                  Pay in Installment
                                </label>
                              </div>
                            )} */}

                            {/* Paying Amount Input */}
                            {/* {isInstallment && (
                              <div>
                                <label className="block text-sm font-medium text-gray-700 mb-1">
                                  Minimum payable amount is (₹29500)
                                </label>

                                <Field
                                  type="number"
                                  placeholder="Enter amount you want to pay"
                                  value={payingAmount}
                                  min={29500}
                                  max={amountBreakdown?.totalAmount}
                                  onChange={(e) => {
                                    let value = Number(e.target.value);
                                    if (value > 0) {
                                      setPayingAmount(value);
                                    } else if (value < 1) {
                                      setPayingAmount("");
                                    }
                                    setFieldValue("paidAmount", value);
                                  }}
                                  className="modern-input w-full pl-10 p-2.5 text-sm border-gray-300 rounded-lg focus:ring-2 focus:ring-green-500"
                                />
                                {payingAmount >
                                  amountBreakdown?.grossAmount && (
                                  <p className="text-red-500 text-xs mt-1">
                                    Maximum payment required is ₹
                                    {formatIndianNumber(
                                      amountBreakdown.setup.total +
                                        amountBreakdown.platform.totalFinal +
                                        amountBreakdown.royalty.total +
                                        amountBreakdown.securityDeposit,
                                    )}
                                  </p>
                                )}
                                {amountBreakdown && (
                                  <p className="text-xs text-gray-500 mt-1">
                                    Total Payable: ₹
                                    {formatIndianNumber(
                                      amountBreakdown.setup.total +
                                        amountBreakdown.platform.totalFinal +
                                        amountBreakdown.royalty.total +
                                        amountBreakdown.securityDeposit,
                                    )}
                                  </p>
                                )}
                              </div>
                            )} */}
                            {/* </div> */}
                            {values.amount > 1000000 && (
                              <div>
                                {/* Instruction Message */}
                                <div className="mt-4 p-2.5 bg-yellow-50 border border-yellow-300 rounded-lg text-sm text-gray-700">
                                  <p className="font-semibold text-yellow-700 mb-1">
                                    Important Payment Instruction
                                  </p>
                                  <p>
                                    If your payment amount is greater than{" "}
                                    <strong>10,00,000</strong>, please scan the
                                    QR code below and complete the payment
                                    directly. After making the payment, upload
                                    the transaction screenshot. Our company will
                                    review the payment and confirm your
                                    registration once the transaction is
                                    verified.
                                  </p>
                                </div>

                                <div className="mt-4 text-center">
                                  <h3 className="text-sm md:text-lg font-semibold mb-2">
                                    Scan to Pay
                                  </h3>

                                  <div className="inline-block p-4 bg-white border border-gray-200 rounded-lg shadow-md">
                                    <img
                                      src="/qr.JPG"
                                      alt="Payment QR Code"
                                      className="w-72 h-72 md:w-72 md:h-72 object-contain"
                                    />
                                    <p className="text-sm text-gray-600 mt-2">
                                      Scan this QR code to make the payment
                                    </p>
                                  </div>
                                </div>

                                <div>
                                  <label className="block text-sm md:text-sm font-semibold">
                                    Payment Screenshot (Required)
                                  </label>

                                  <button
                                    type="button"
                                    className="w-full mt-1 p-2 bg-[#00C70D] text-white rounded-lg text-sm hover:bg-green-700 transition-colors duration-200"
                                    onClick={() =>
                                      document
                                        .getElementById("screenshot")
                                        .click()
                                    }
                                  >
                                    Upload
                                  </button>

                                  <input
                                    type="file"
                                    id="screenshot"
                                    name="screenshot"
                                    accept="image/*"
                                    className="hidden"
                                    onChange={(event) =>
                                      setFieldValue(
                                        "screenshot",
                                        event.currentTarget.files[0],
                                      )
                                    }
                                  />

                                  {values.screenshot && (
                                    <div className="mt-1 text-xs text-green-600">
                                      {values.screenshot.name ||
                                        "File uploaded"}
                                    </div>
                                  )}

                                  <ErrorMessage
                                    name="screenshot"
                                    component="div"
                                    className="text-red-500 text-xs mt-1"
                                  />
                                </div>
                              </div>
                            )}
                          </>
                        )}
                        {step === 4 && (
                          <>
                            <div className="mt-4">
                              <h3 className="text-xl md:text-2xl font-bold bg-gradient-to-r from-[#00C70D] to-[#005AD0] bg-clip-text text-transparent">
                                Terms and Conditions
                              </h3>
                              <p className="text-gray-500 text-xs md:text-sm mb-4">
                                Terms and Conditions for Channel Partner
                                Enrollment
                              </p>
                              <div className="max-w-3xl mx-auto p-6 bg-white rounded-2xl shadow-lg border border-gray-100">
                                <h2 className="text-2xl font-bold text-gray-800 mb-4">
                                  Channel Partner Agreement Terms & Conditions
                                </h2>
                                <div className="max-h-[400px] overflow-y-auto p-4 bg-gray-50 rounded-lg scrollbar-thin scrollbar-thumb-gray-500 scrollbar-track-gray-100 scrollbar-thumb-rounded-full">
                                  <div className="text-gray-700 font-['Poppins'] text-sm leading-relaxed">
                                    <p className="mb-4 text-gray-600">
                                      This{" "}
                                      <span className="font-semibold">
                                        Agreement
                                      </span>{" "}
                                      governs the enrollment and participation
                                      of individuals or entities (“Channel
                                      Partner”) in the distribution of the
                                      Global Digital Health Smart Card, offered
                                      by LifeOnPlus (“Company”). By enrolling as
                                      a Channel Partner, you agree to comply
                                      with and be bound by the following terms:
                                    </p>
                                    <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3 flex items-center">
                                      <span className="inline-block w-6 h-6 bg-blue-500 text-white rounded-full text-center mr-2">
                                        1
                                      </span>
                                      Eligibility & Enrollment
                                    </h3>
                                    <ul className="list-disc pl-6 space-y-2">
                                      <li>
                                        Channel Partner must be 18 years of age
                                        or above and legally competent to enter
                                        into this Agreement.
                                      </li>
                                      <li>
                                        Enrollment is subject to approval by the
                                        Company, and the Company reserves the
                                        right to reject or terminate any
                                        enrollment without assigning reasons.
                                      </li>
                                      <li>
                                        The Channel Partner must provide
                                        accurate details including PAN, GST (if
                                        applicable), and banking details for
                                        settlements.
                                      </li>
                                    </ul>
                                    <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3 flex items-center">
                                      <span className="inline-block w-6 h-6 bg-blue-500 text-white rounded-full text-center mr-2">
                                        2
                                      </span>
                                      Roles & Responsibilities
                                    </h3>
                                    <ul className="list-disc pl-6 space-y-2">
                                      <li>
                                        The Channel Partner is authorized to
                                        promote, market, and distribute Global
                                        Digital Health Smart Cards strictly as
                                        per Company guidelines.
                                      </li>
                                      <li>
                                        Misrepresentation of product benefits,
                                        features, or unauthorized claims is
                                        strictly prohibited.
                                      </li>
                                      <li>
                                        The Channel Partner shall not engage in
                                        activities that may harm the reputation
                                        or goodwill of the Company.
                                      </li>
                                      <li>
                                        All marketing, training, and branding
                                        materials shall be provided/approved by
                                        the Company.
                                      </li>
                                    </ul>
                                    <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3 flex items-center">
                                      <span className="inline-block w-6 h-6 bg-blue-500 text-white rounded-full text-center mr-2">
                                        3
                                      </span>
                                      Financial Terms
                                    </h3>
                                    <ul className="list-disc pl-6 space-y-2">
                                      <li>
                                        Channel Partner earnings shall be based
                                        on the Company’s distribution margin,
                                        referral structure, and wallet system as
                                        communicated from time to time.
                                      </li>
                                      <li>
                                        All settlements will be made net of
                                        applicable TDS, service fees, GST, and
                                        other statutory deductions.
                                      </li>
                                      <li>
                                        No fixed returns, interest, or
                                        guaranteed income is offered. Earnings
                                        depend solely on sales and business
                                        performance.
                                      </li>
                                    </ul>
                                    <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3 flex items-center">
                                      <span className="inline-block w-6 h-6 bg-blue-500 text-white rounded-full text-center mr-2">
                                        4
                                      </span>
                                      Intellectual Property
                                    </h3>
                                    <ul className="list-disc pl-6 space-y-2">
                                      <li>
                                        The Channel Partner is granted a
                                        non-exclusive, non-transferable right to
                                        use the Company’s name, logo, and
                                        promotional materials solely for
                                        business purposes.
                                      </li>
                                      <li>
                                        Any misuse of Company’s intellectual
                                        property shall result in termination and
                                        legal action.
                                      </li>
                                    </ul>
                                    <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3 flex items-center">
                                      <span className="inline-block w-6 h-6 bg-blue-500 text-white rounded-full text-center mr-2">
                                        5
                                      </span>
                                      Confidentiality
                                    </h3>
                                    <ul className="list-disc pl-6 space-y-2">
                                      <li>
                                        The Channel Partner shall maintain
                                        strict confidentiality of all Company
                                        data, agreements, pricing structures,
                                        and business models.
                                      </li>
                                      <li>
                                        Sharing or misusing Company information
                                        with competitors or third parties is
                                        prohibited.
                                      </li>
                                    </ul>
                                    <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3 flex items-center">
                                      <span className="inline-block w-6 h-6 bg-blue-500 text-white rounded-full text-center mr-2">
                                        6
                                      </span>
                                      Termination
                                    </h3>
                                    <ul className="list-disc pl-6 space-y-2">
                                      <li>
                                        The Company reserves the right to
                                        suspend or terminate the partnership at
                                        any time in case of non-compliance with
                                        this Agreement.
                                      </li>
                                      <li>
                                        Upon termination, all rights to
                                        represent the Company or distribute
                                        products shall cease immediately.
                                      </li>
                                    </ul>
                                    <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3 flex items-center">
                                      <span className="inline-block w-6 h-6 bg-blue-500 text-white rounded-full text-center mr-2">
                                        7
                                      </span>
                                      Dispute Resolution & Jurisdiction
                                    </h3>
                                    <ul className="list-disc pl-6 space-y-2">
                                      <li>
                                        Any disputes arising out of or in
                                        connection with this Agreement shall
                                        first be attempted to be resolved
                                        amicably through mutual discussion.
                                      </li>
                                      <li>
                                        Failing amicable settlement, disputes
                                        shall be referred to Arbitration under
                                        the Arbitration and Conciliation Act,
                                        1996.
                                      </li>
                                      <li>
                                        The Arbitrator shall be appointed solely
                                        by the Company, and the decision of the
                                        Arbitrator shall be final and binding.
                                      </li>
                                      <li>
                                        The courts at Bangalore, Karnataka,
                                        shall have exclusive jurisdiction.
                                      </li>
                                    </ul>
                                    <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-3 flex items-center">
                                      <span className="inline-block w-6 h-6 bg-blue-500 text-white rounded-full text-center mr-2">
                                        8
                                      </span>
                                      Governing Law
                                    </h3>
                                    <ul className="list-disc pl-6 space-y-2">
                                      <li>
                                        This Agreement shall be governed by and
                                        construed in accordance with the laws of
                                        India.
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="mt-4">
                                <label className="flex items-center text-sm md:text-base font-['Poppins'] max-w-full">
                                  <Field
                                    type="checkbox"
                                    name="agreement"
                                    className="mr-2 h-4 w-4"
                                  />
                                  <span>
                                    I agree to the Terms and Conditions{" "}
                                    <span className="text-red-500 font-semibold">
                                      (Required)
                                    </span>{" "}
                                    and understand that this investment secures
                                    exclusive rights for the selected region,
                                    subject to verification by LifeOnPlus. I
                                    confirm all information provided is true to
                                    the best of my knowledge.
                                  </span>
                                </label>
                                <ErrorMessage
                                  name="agreement"
                                  component="div"
                                  className="text-red-500 text-xs mt-1"
                                />
                              </div>
                            </div>
                          </>
                        )}
                        <div className="flex justify-between mt-4">
                          {step > 0 && (
                            <Button
                              onClick={() => setStep(step - 1)}
                              disabled={isSubmitting}
                              className="px-4 py-2 bg-[#1DA1F2] text-white font-['Poppins'] rounded-lg hover:bg-blue-600 transition-colors duration-200 disabled:bg-gray-300 disabled:text-gray-600"
                            >
                              Back
                            </Button>
                          )}
                          <Button
                            type="submit"
                            disabled={
                              isSubmitting || (step === 4 && !values.agreement)
                            }
                            className="px-4 py-2 bg-[#00C70D] text-white font-['Poppins'] rounded-lg hover:bg-green-700 transition-colors duration-200 disabled:bg-gray-300 disabled:text-gray-600"
                          >
                            {step === formSteps.length - 1 ? "Submit" : "Next"}
                          </Button>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <>
      <Modal show={showModal} onHide={handleClose} centered size="xl">
        <Modal.Body className="p-0">
          <div className="flex flex-col sm:flex-row min-h-[600px] sm:min-h-[842px]">
            {!isPlusMode && (
              <div className="w-full sm:w-1/4 bg-gradient-to-b from-white to-green-500 px-6 py-10 flex flex-col">
                <div className="mb-6">
                  <p className="text-md text-center font-semibold my-4">
                    Steps to register as Franchise
                  </p>
                  <img
                    src="/lifeon.svg"
                    alt="LifeOnPlus Logo"
                    className="w-24 mx-auto mb-4"
                  />
                  <p className="text-sm">
                    {" "}
                    Follow the Steps to Register as a Franchise, to start your
                    jouney with Lifeonplus!
                  </p>
                </div>

                <div className="space-y-6">
                  {steps.map((label, index) => (
                    <div
                      key={index}
                      className="flex items-center gap-4 cursor-pointer"
                      onClick={() =>
                        isStepCompleted(index) && setCurrentStep(index)
                      }
                    >
                      <div className="relative">
                        <div
                          className={`w-10 h-10 rounded-full flex items-center justify-center ${
                            index <= currentStep
                              ? "bg-green-600 text-white"
                              : isStepCompleted(index)
                                ? "bg-green-400 text-white"
                                : "bg-white text-green-600 border border-green-600"
                          }`}
                        >
                          {isStepCompleted(index) && index > currentStep ? (
                            <FaCheckCircle />
                          ) : (
                            index + 1
                          )}
                        </div>
                        {index < steps.length - 1 && (
                          <div
                            className={`absolute left-1/2 w-0.5 h-6 top-full ${
                              index < currentStep
                                ? "bg-green-600"
                                : "bg-gray-300"
                            }`}
                          ></div>
                        )}
                      </div>
                      <span
                        className={`text-base ${
                          index === currentStep
                            ? "font-semibold text-green-800"
                            : "text-gray-800"
                        }`}
                      >
                        {label}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            )}
            <div className={`w-full ${isPlusMode ? "" : "sm:w-3/4"} bg-white`}>
              <StepContent step={currentStep} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <ApplicationFormModal />
      <Modal
        show={showThankYou}
        onHide={handleCloseThankYou}
        centered
        dialogClassName="modal-90w md:modal-lg"
      >
        <Modal.Body className="p-4 md:p-6">
          <div className="relative bg-white rounded-lg text-center py-6">
            <button
              onClick={handleCloseThankYou}
              className="absolute top-2 right-2 bg-transparent border-0"
            >
              <FaTimes size={16} color="#666" />
            </button>
            <h2 className="text-lg md:text-xl font-bold text-green-600">
              Thank You for Your Application!
            </h2>
            <p className="text-gray-500 text-sm md:text-base mt-2">
              Your application has been successfully submitted. We will review
              your details and get back to you soon.
            </p>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default FranchiseSignUp;
